import { useAtomValue } from 'jotai';
import { toast } from 'sonner';

import { ManipulatorState_StowState } from 'lib/generated/proto/bosdyn/api/robot_state';
import { useSendRobotCommand } from 'lib/handlers/robot-command';

// import { useRosService } from '../../../../hooks/ros';
// import { useRobotArmLoading } from '../../../robot-control';
import { manipulatorStateStowedSelector } from './selectors';

/**
 * Weather the arm is stowed or not on robot side
 * @return
 */
export function useArmStowed() {
  const { stowState } = useAtomValue(manipulatorStateStowedSelector);
  // const { loading, setLoading } = useRobotArmLoading();

  const stowed = stowState === ManipulatorState_StowState.STOWSTATE_STOWED;
  const deployed = stowState === ManipulatorState_StowState.STOWSTATE_DEPLOYED;
  const unknown = stowState === ManipulatorState_StowState.STOWSTATE_UNKNOWN;

  // const ros = useRosService();
  const { sendArmStowCommand, result } = useSendRobotCommand();

  function handleStowArm() {
    // setLoading(true);
    // return ros.RosServices.armStow().finally(() => setLoading(false));
    return sendArmStowCommand(true);
  }

  function handleDeployArm() {
    // setLoading(true);
    // return ros.RosServices.armUnStow().finally(() => setLoading(false));
    return sendArmStowCommand(false);
  }

  async function handleToggleStowArm() {
    if (unknown) {
      return toast.error('Error: Current arm stow state unknown');
    }
    if (stowed) {
      await handleDeployArm();
    } else if (deployed) {
      await handleStowArm();
    }
  }

  return {
    stowed,
    deployed,
    unknown,
    stowState,
    handleToggleStowArm,
    handleDeployArm,
    handleStowArm,
    result,
  };
}
